/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Load_ButtonInputs */



/**
* | output |
* | --- |
* | "Load" |
*
* @param {Audio_Description_Export_Load_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_load_button = /** @type {((inputs?: Audio_Description_Export_Load_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Load_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger")
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нагрузка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("負荷")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar")
	return /** @type {LocalizedString} */ ("Load")
});